import { AxiosError } from 'axios';

import { ApiErrorResponse } from './types';

export const isUnauthorizedError = (error?: AxiosError<ApiErrorResponse>): boolean => {
  const status = error?.response?.status;

  return status === 401 || status === 403;
};
